export default "__VITE_ASSET__BESUY_3r__"